import React from 'react';
import Card from '../components/Card';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import CommentPreview from '../post/comment/CommentPreview';
import commentThreadPath from '../utils/url/commentThreadPath';

const ACTIVITY_COMMENT_CARD_COMMENT_FRAGMENT = gql(`
  fragment ActivityCommentCard_comment on Comment {
    id
    content
    thread {
      id
      ...commentThreadPath_thread
    }
  }
`);

interface ActivityCommentCardProps {
  comment: DocumentType<typeof ACTIVITY_COMMENT_CARD_COMMENT_FRAGMENT>;
}

const ActivityCommentCard = ({ comment }: ActivityCommentCardProps) => {
  const { thread, content } = comment;
  const threadPath = thread ? commentThreadPath(thread) : null;
  return (
    <Card ignoreInsideLinks to={threadPath ?? undefined}>
      <CommentPreview content={content} maxLines={8} />
    </Card>
  );
};

export default ActivityCommentCard;
